/**
* Types de filtres applicables * 
*******************************/
enum PinTypeEnum {
    None = 0,
    Root = 1,
    Tree = 2
}

export default PinTypeEnum;